export { cacheService } from './CacheService'
export type { CacheKey, CacheOptions } from './CacheService'
